import { type FunctionComponent } from 'react';
import { type Maybe, type ProductViewEnum } from '../../../__generated__/graphql-client-types';
import { SearchVariantContextProvider } from '../../../contexts/search/search-variant.context';
import { useSearchResults } from '../../../hooks/apollo/search/search.hooks';
import { type DropType } from '../../../types/search.types';
import { SearchProductCard } from '../search-product-card/search-product-card.component';
import { SearchProductCardSkeletonList } from '../search-product-card-skeleton/search-product-card-skeleton.component';

export type SearchResultsProps = {
	viewType?: Maybe<ProductViewEnum>;
	dropType?: DropType;
};

export const SearchResults: FunctionComponent<SearchResultsProps> = ({ viewType, dropType }) => {
	const { results, previousResults, loading, page, isNonstock, isNewLookAndFeelProductCard, createGTMEvent } = useSearchResults();
	const showResults = loading ? previousResults : results;

	return (
		<>
			{showResults?.products && (
				<div className={`flex ${viewType === 'LIST' ? 'flex-column flex-row-ns' : ''} flex-wrap ml3-l`}>
					{showResults.products.map((product, index) => {
						if (product.variants) {
							const initialVariant = product.variants.find((v) => v.id === product.id) ?? product.variants[0];
							return (
								<SearchVariantContextProvider variant={initialVariant} key={`${initialVariant.id}-${index}`}>
									<SearchProductCard
										dropType={dropType}
										product={product}
										viewType={viewType}
										cardIndex={index}
										page={page}
										searchId={showResults.searchId}
										isNonstockSearch={isNonstock}
										isNewLookAndFeel={isNewLookAndFeelProductCard}
										createGTMEvent={createGTMEvent}
									/>
								</SearchVariantContextProvider>
							);
						}
						return null;
					})}
				</div>
			)}
			{loading && (
				<div className="absolute top-0 w-100 h-100 bg-theme-white-o70 z-1">
					<div className="sticky top-0">
						<SearchProductCardSkeletonList viewType={viewType} />
					</div>
				</div>
			)}
		</>
	);
};
